<template>
  <section class="t-datepicker-range" v-click-out="handleClickOut">
    <Aside
      @setFilter="handleSetFilter"
      :activeFilter="selectedFilter"
      :locale="localeFixed"
    />

    <div class="t-datepicker-range-content">
      <DateFields
        :startDate="selectedDateRange.start"
        :endDate="selectedDateRange.end"
        :locale="localeFixed"
      />

      <div class="t-datepicker-range-calendar">
        <DatePicker
          :columns="2"
          :locale="localeFixed"
          :step="1"
          :value="selectedDateRange"
          @input="handleInput"
          is-range
        />
      </div>

      <div class="t-datepicker-range-action">
        <Button :handleClick="handleCancel" type="tertiary">
          {{ buttonLabels.cancel }}
        </Button>
        <Button :handleClick="handleApply">
          {{ buttonLabels.apply }}
        </Button>
      </div>
    </div>
  </section>
</template>

<script>
import Aside from './Aside.vue';
import DateFields from './DateFields.vue';
import DatePicker from './DatePicker.vue';
import Button from '../Button/Button.vue';
import { filters, i18nButtonLabels } from './filters';
import clickOutDirective from '../../utils/clickoutDirective';

export default {
  name: 't-datepicker-range',
  data() {
    return {
      selectedDateRange: {},
      selectedFilter: filters.ALL_PERIOD,
    };
  },
  props: {
    filter: { type: Number },
    range: { type: Object, required: true },
    locale: {
      type: String,
      default: 'pt-BR',
      validator: (value) => ['en-US', 'es-ES', 'pt-BR', 'en_US', 'es_ES', 'pt_BR'].includes(value),
    },
  },
  components: {
    Aside,
    Button,
    DateFields,
    DatePicker,
  },
  directives: {
    ...clickOutDirective,
  },
  emit: ['apply', 'cancel', 'click-out', 'input'],
  watch: {
    filter(newFilter) {
      this.selectedFilter = newFilter;
    },
    range(newRange) {
      this.selectedDateRange = newRange;
    },
  },
  computed: {
    emitData() {
      return {
        dateRange: this.selectedDateRange,
        filter: this.selectedFilter,
      };
    },
    localeFixed() {
      return this.locale.replace('_', '-');
    },
    buttonLabels() {
      return i18nButtonLabels[this.localeFixed];
    },
  },
  methods: {
    handleApply() {
      this.$emit('apply', this.emitData);
    },
    handleCancel() {
      this.$emit('cancel', this.emitData);
    },
    handleClickOut() {
      this.$emit('click-out');
    },
    handleInput(value) {
      this.selectedFilter = 0;
      if (value !== null) {
        this.selectedDateRange = value;
      }
      this.$emit('input', this.emitData);
    },
    handleSetFilter({ dateRange, filter }) {
      this.selectedDateRange = dateRange;
      this.selectedFilter = filter;
    },
  },
  created() {
    this.selectedDateRange = this.range;
    this.selectedFilter = this.filter;

    if (this.filter === null) {
      this.selectedFilter = undefined;
    }
  },
};
</script>

<style lang="scss" scoped>
.t-datepicker-range {
  background-color: var(--track-color-white);
  border-radius: var(--track-border-radius-sm);
  box-shadow: var(--track-shadow-sm);
  display: flex;
  padding: var(--track-spacing-bg);
  width: fit-content;
}

.t-datepicker-range-content {
  align-items: flex-end;
  display: flex;
  flex-direction: column;
}

.t-datepicker-range-icon {
  align-items: center;
  display: flex;
  justify-content: center;
  width: var(--track-spacing-lg);
}

.t-datepicker-range-calendar {
  margin-top: var(--track-spacing-lg);
  margin-bottom: var(--track-spacing-md);
}
</style>
